import {userConstants} from '../../_constants';

export function listServiceDelivery(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_LIST_SERVICE_DELIVERY_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_LIST_SERVICE_DELIVERY_SUCCESS:
      return {
        loading: false,
        dataServiceDelivery: action.data,
        //...action.data,
      };
    case userConstants.GET_LIST_SERVICE_DELIVERY_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
